import React from "react";
import { Modal } from "./Modal";

interface DeleteConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  itemName: string;
  loading?: boolean;
}

export const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  itemName,
  loading = false
}) => {
  const handleConfirm = () => {
    onConfirm();
  };

  const footer = (
    <>
      <button
        type="button"
        className="ob-button ob-button-ghost"
        onClick={onClose}
        disabled={loading}
      >
        Cancel
      </button>
      <button
        type="button"
        className="ob-button ob-button-danger"
        onClick={handleConfirm}
        disabled={loading}
      >
        {loading ? "Deleting..." : "Delete"}
      </button>
    </>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      subtitle={`Are you sure you want to delete "${itemName}"? This action cannot be undone.`}
      footer={footer}
    >
      <div></div>
    </Modal>
  );
};
